module.exports = __webpack_public_path__ + "media/club_product_v2/5-2549cc23.webp";